module.exports = __webpack_public_path__ + "img/museu-arte-pantaneira.e3a1fa3c.jpg";